import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(date: string, format: any = '', currentFormat = ''): any {
    return moment(date, currentFormat).format(format);
  }
}
